import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import * as R from "ramda";
import {codeTables} from "../../codes";
import moment from "moment";

export const bidViewSelector = createSelector(
  state => state.view.data,
  state => state.companies.data,
  (bids, companies) => Object.values(bids).map(bid => ({
    ...bid,
    resource: {
      ...bid.resource,
      company: companies[(bid.resource || {}).ownercompanyid]
    }
  }))
);

export const bidStatusSelector = createSelector(
  state => state.reports.by_status.bids,
  (bidstatus) => {
    if (!bidstatus || !bidstatus.resource) return [];
    bidstatus = R.map(
      ({ status, count }) => ({
        key: codeTables.get('bidstatus').find(code => code.code === status),
        value: count
      }),
      bidstatus.resource
    );
    return bidstatus;
  }
);

export const bidCalendarSelector = createSelector(
  state => state.reports.calendar.bids,
  (bidcalendar) => {
    if (!bidcalendar || !bidcalendar.resource) return [];
    bidcalendar = R.map(R.pipe(
      (value) => ({ ...value, date: moment(value.date) })
    ), bidcalendar.resource);
    return bidcalendar;
  }
);




// WEBPACK FOOTER //
// ./src/components/Bids/selectors.js